import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailshotComponent } from './mailshot/mailshot.component';
import { MailshotRoutingModule } from './mailshot-routing.module';
import { AppCommonModule } from '@app/components/app.common.module';
import { ModalMailshotComponent } from './modal-mailshot/modal-mailshot.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailsMailshotComponent } from './details-mailshot/details-mailshot.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    MailshotComponent,
    ModalMailshotComponent,
    DetailsMailshotComponent,
  ],
  imports: [
    AppCommonModule,
    CommonModule,
    MailshotRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class MailshotModule {}
